import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface NotificationSchedulePayload {
  id?: number;                // optionnel pour édition
  applicationId: number;
  title: string;
  description: string;
  descriptionFr?: string;
  descriptionEn?: string;

  daysOfWeek: string[];       // ['monday', 'tuesday', ...]
  startTime?: string | null;  // '10:00'
  endTime?: string | null;    // '20:00'
  intervalMinutes?: number | null;

  unlimitedTime: boolean;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationScheduleService {

  private readonly API_URL = `${environment.apiUrl}notification/schedule`;

  constructor(private http: HttpClient) {}


  save(payload: NotificationSchedulePayload): Observable<any> {
    return this.http.post<any>(this.API_URL, payload, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }).pipe(
      catchError(this.handleError)
    );
  }


  getList(parameters: {[param: string]: string | string[]}) {
    console.log(this.API_URL)
    return this.http.get(`${environment.apiUrl}notification/all`, {params: parameters});
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`).pipe(
      catchError(this.handleError)
    );
  }


  private handleError(error: HttpErrorResponse) {
    console.error('NotificationSchedule API error', error);

    let message = 'Erreur inconnue';
    if (error.error?.message) {
      message = error.error.message;
    }

    return throwError(() => new Error(message));
  }

  deleteNotification(id: number) {
    return this.http.delete(`${environment.apiUrl}notification/delete/${id}`);
  }

}
